import 'babel-polyfill'

import Vue from 'vue'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import VueGtm from '@gtm-support/vue2-gtm'

import { store } from '@/store/store'
import router from './router'

import vuetify from '@/plugins/vuetify'
import breadcrumbs from '@/plugins/breadcrumbs'
import veeValidate from '@/plugins/veeValidate'
import asynccomputed from '@/plugins/asynccomputed'
import notify from '@/plugins/notify'
import globalComponents from '@/plugins/globalComponents'

// Assets
import './lib/VuelyCss'
import '@mdi/font/css/materialdesignicons.css'

// app.vue
import App from './App'
// Facebook Pixel
Vue.use(VueFacebookPixel, { router })

// https://www.npmjs.com/package/@gtm-support/vue2-gtm/v/1.3.0?activeTab=readme
Vue.use(VueGtm, {
  id: 'GTM-NL6WSR8',
  defer: true,
  compatibility: false,
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  // ignoredViews: ['dashboard'],
  trackOnNextTick: false
})

if (process.env.NODE_ENV === 'production') {
  Vue.analytics.fbq.init('475928312581100')
}

new Vue({
  vuetify,
  breadcrumbs,
  veeValidate,
  asynccomputed,
  notify,
  globalComponents,
  router,
  store,
  $_veeValidate: {
    validator: 'new'
  },
  render: h => h(App)
}).$mount('#app')
